import React from 'react';
import { DataTableType } from '../../components/Table';
import { TableHeaders } from './consts';
import { Cession } from '../../../types/cession';
import moment from 'moment';
import { parseCheckCurrency } from '../Checks/utils';

export const formatDataToTable = (cessions: Cession[]): DataTableType[] => {
  return cessions.reduce((accumulator: DataTableType[], cession: Cession) => {
    const value: DataTableType = {
      [TableHeaders.ID]: cession._id,
      [TableHeaders.CLIENT]: <div>{cession.client?.name || '-'}</div>,
      [TableHeaders.ENTITY]: <div>{cession.entity || '-'}</div>,
      [TableHeaders.STATE]: cession.state,
      [TableHeaders.EXPIRATION]: (<div> {cession.proposedExpiration ? moment(cession.proposedExpiration, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-'}</div>),
      // [TableHeaders.AMOUNT]: (
      //   <div style={{ textAlign: 'end' }}>
      //     {cession.currency}{' '}
      //     {typeof cession.advanceAmount === 'number'
      //       ? parseFloat(cession.advanceAmount?.toString() || '')
      //         .toFixed(2)
      //         .replace(/\./g, '#')
      //         .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      //         .replace(/,/g, '.')
      //         .replace(/#/g, ',')
      //       : '-'}
      //   </div>
      // ),
      [TableHeaders.AMOUNT]: (
        <div
          style={{
            display: 'inline-flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            fontFamily: 'monospace',
            fontVariantNumeric: 'tabular-nums',
            width: '130px', // ajustar a cantidad de digitos
            gap: '0.3ch', // ajusta la separación fina
          }}
        >
          <span style={{ width: '3ch', textAlign: 'right', display: 'inline-block' }}>
            {parseCheckCurrency(cession.currency)}
          </span>
          <span style={{ textAlign: 'right', flex: 1 }}>
            {parseFloat(cession.advanceAmount?.toString() || '0')
              .toFixed(2)
              .replace(/\./g, '#')
              .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
              .replace(/,/g, '.')
              .replace(/#/g, ',')}
          </span>
        </div>
      ),
    };
    return [...accumulator, value];
  }, []);
};

export const csvHeaderAdapt = (key: string): string => {
  const labels: { [key: string]: string } = {
    _id: 'ID',
    clientId: 'ID Cliente',
    operationId: 'Id Operacion',
    associatedInvoice: 'Factura Asociada',
    entity: 'Ente',
    advanceDate: 'Fecha Adelanto',
    currency: 'Moneda',
    advanceAmount: 'Monto Adelanto',
    proposedExpiration: 'Vencimiento Propuesto',
    agreedRate: 'Tasa Acordada',
    observations: 'Observaciones',
    processedBy: 'Procesado Por',
    channeledBy: 'Canalizado Por',
    creationDate: 'Fecha de Creación',
  };
  return labels[key] || key;
};
